import React, { ChangeEvent } from 'react';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import Paths from '@root/utils/Path';
import { compose } from 'react-apollo';
import { withRouter, RouterProps } from 'react-router';
import { userList_listUsers_data, userList, userListVariables } from '@api/graphql/types';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { Async } from 'react-select';
import { ApolloQueryResult } from "apollo-client";

interface State {
    isLoading: boolean;
    user?: userList_listUsers_data;
    name: string;
    ext_id: string;
    email: string;
}


class UserSearchForm extends React.Component<{} & RouterProps & InjectedIntlProps, State> {

    public state = {
        isLoading: false,
        user: undefined,
        ext_id: '',
        name: '',
        email: '',
    };

    private async getUsers(filters: {ext_id?: string, email?: string, name?: string}) {
        const response: ApolloQueryResult<userList> = await GraphQLClient.query<userList, userListVariables>({
            query: Queries.userList,
            variables: {filters, count: 100, page: 1},
        });
        if (response.data.listUsers && response.data.listUsers.data.length) {
            const users = response.data.listUsers.data;
            if (users.length === 1) {
                const user = users[0];
                this.setState({isLoading: false, user, ext_id: user.ext_id, email: user.email, name: user.name});
                return;
            }
        }
        const { name, ext_id, email } = this.state;
        this.setState({isLoading: false, user: undefined, name, ext_id, email});
    }

    private extIdChange = (e: ChangeEvent<HTMLInputElement>) => {
        const extId = e.currentTarget.value;
        this.setState({user: undefined, ext_id: extId, email: '', name: '', isLoading: true}, async () => {
            this.getUsers({ext_id: extId});
        });
    }

    private loadOptionsByName = (inputValue: string) => {
        return new Promise(resolve => {
            GraphQLClient.query<userList>({query: Queries.userList, variables: {filters: {name: inputValue}, count: 30, page: 1}})
                .then(options => {
                    if (options.data.listUsers && options.data.listUsers.data) {
                        resolve(options.data.listUsers.data.map((user) => {
                            return {value: user.ext_id, label: user.name};
                        }));
                    }
                });
        });
    }

    private loadOptionsByEmail = (inputValue: string) => {
        return new Promise(resolve => {
            GraphQLClient.query<userList>({query: Queries.userList, variables: {filters: {email: inputValue}, count: 30, page: 1}})
                .then(options => {
                    if (options.data.listUsers && options.data.listUsers.data) {
                        resolve(options.data.listUsers.data.map((user) => {
                            return {value: user.ext_id, label: user.email};
                        }));
                    }
                });
        });
    }

    public render() {
        const user = this.state.user ? this.state.user : undefined;

        return (
            <form className="form-horizontal">
                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.ext_id.title'})}</label>
                    <div className="col-sm-8">
                        <input type="text" value={this.state.ext_id} name="ext_id" placeholder={this.props.intl.formatMessage({id: 'module.dashboard.ext_id.title'})} className="form-control" onChange={this.extIdChange} />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.email.title'})}</label>

                    <div className="col-sm-8">
                        <Async
                            loadOptions={this.loadOptionsByEmail}
                            value={{value: this.state.ext_id, label: this.state.email}}
                            onChange={(value: {value: string, label: string}) => {
                                this.getUsers({ext_id: value.value});
                            }}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4">{this.props.intl.formatMessage({id: 'module.dashboard.name.title'})}</label>

                    <div className="col-sm-8">
                        <Async
                            loadOptions={this.loadOptionsByName}
                            value={{value: this.state.ext_id, label: this.state.name}}
                            onChange={(value: {value: string, label: string}) => {
                                this.getUsers({ext_id: value.value});
                            }}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <div className="col-sm-12">
                        <button
                            className="btn btn-primary btn-block"
                            disabled={!user}
                            onClick={() => {
                                if (user) {
                                    // @ts-ignore
                                    this.props.history.push(`${Paths.user}/${user!.id}`);
                                }
                            }}
                        >{this.state.isLoading ? this.props.intl.formatMessage({id: 'common.loading'}) : this.props.intl.formatMessage({id: 'common.open'})}</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(UserSearchForm);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/components/UserSearchForm.tsx